require("./app.js");
require("./app-beta.less");



// WEBPACK FOOTER //
// ./src/app-beta.js